// src/components/InactivityHandler.js
import { useEffect, useRef } from 'react';

const InactivityHandler = ({ onLogout, children }) => {
  const timeoutRef = useRef(null);
  const maxInactivityTime = 120 * 60 * 1000; // 2hrs

  const resetTimer = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      alert('Logged out due to inactivity');
      onLogout(); // call the logout handler
    }, maxInactivityTime);
  };

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];

    // Bind reset on activity
    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer(); // initialize timer

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      clearTimeout(timeoutRef.current);
    };
  }, []);

  return children;
};

export default InactivityHandler;
